module.exports = __webpack_public_path__ + "static/media/clinical-investigation-bg.21d885e2.png";